import { faComment, faHouse, faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NeighborhoodServiceAreaInfo } from 'rwl-shared/dist/models';
import styled from 'styled-components6';
import { Body1, H6 } from 'rwl-ui';
import { VerticalDivider } from '../../components';
import { useBreakpoint } from '../../providers';
import { When } from 'react-if';

const StatsContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
`;

const Stat = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const StatCount = styled.div`
    display: flex;
    align-items: center;
`;

export const ServiceAreaStats = ({
    neighborhood,
}: {
    neighborhood: NeighborhoodServiceAreaInfo | undefined;
}) => {
    const { isBelowBreakpoint } = useBreakpoint();
    return (
        <StatsContainer
            style={{ width: isBelowBreakpoint('sm') ? '100%' : '50%' }}
        >
            <Stat>
                <StatCount>
                    <FontAwesomeIcon
                        style={{
                            marginRight: 'var(--rwl-spacing-sm)',
                        }}
                        icon={faHouse}
                        size="xs"
                    />
                    <H6>{neighborhood?.jobCount || 0}</H6>
                </StatCount>
                <Body1 style={{ color: 'var(--rwl-text-hint)' }}>
                    Projects
                </Body1>
            </Stat>
            <When condition={!!neighborhood?.reviewCount}>
                <VerticalDivider
                    style={{
                        height: '2.75em',
                        color: 'var(--rwl-palette-gray-500)',
                    }}
                />
                <Stat>
                    <StatCount>
                        <FontAwesomeIcon
                            style={{
                                marginRight: 'var(--rwl-spacing-sm)',
                            }}
                            icon={faComment}
                            size="xs"
                        />
                        <H6>{neighborhood?.reviewCount || 0}</H6>
                    </StatCount>
                    <Body1 style={{ color: 'var(--rwl-text-hint)' }}>
                        Reviews
                    </Body1>
                </Stat>

                <VerticalDivider
                    style={{
                        height: '2.75em',
                        color: 'var(--rwl-palette-gray-500)',
                    }}
                />
                <Stat>
                    <StatCount>
                        <FontAwesomeIcon
                            style={{
                                marginRight: 'var(--rwl-spacing-sm)',
                            }}
                            icon={faStar}
                            size="xs"
                        />
                        <H6>{neighborhood?.averageRating?.toFixed(1) || 0}</H6>
                    </StatCount>
                    <Body1 style={{ color: 'var(--rwl-text-hint)' }}>
                        Avg. rating
                    </Body1>
                </Stat>
            </When>
        </StatsContainer>
    );
};
